import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
} from "chart.js";
import { Bar, Line } from "react-chartjs-2";
import { cn } from "../../../../utils/useFunctions";
import {
  STYLE_PDF_TEXT_MEDIUM_11,
  STYLE_PDF_TEXT_MEDIUM_BLUE_12,
  STYLE_PDF_TEXT_NORMAL_10,
} from "../../styles/pdf.style";
import { useUserStore } from "../../../../_store/userStore";
import { useEffect, useState } from "react";
import api from "../../../../api/api.main";
import numeral from "numeral";
import {
  SumDebtPersonalValue,
  SumOtherDebtAmount,
} from "../../../../functions/Balance/sumValueBalance";
import {
  sumCapitalInvest,
  sumDebtInvest,
} from "../../../../functions/Balance/sumProperty";

// Register Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend
);

const AnalysisTableTwo = () => {
  // Years for the x-axis

  const userData = useUserStore((state) => state.userData);

  const [allData, setAllData] = useState([]);

  const [ReturnInsurance, setReturnInsurance] = useState([
    [{}],
    [{}],
    [{}],
    [{}],
  ]);
  const THisYear = new Date().getFullYear() + 543;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data: dataStorage } = await api.get(
          `/storages/profileAll/${userData?._id}`
        );

        if (dataStorage?.storages?.length < 4) {
          for (let index = dataStorage?.storages?.length; index < 4; index++) {
            dataStorage?.storages.push({});
          }
        }

        setAllData(dataStorage?.storages);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [userData?._id]);

  useEffect(() => {
    if (allData?.length === 0) {
      return;
    }

    allData?.map((itemA, index) => {
      let tempBalance = itemA?.balanceData;
      if (tempBalance) {
        let tempInsuranceReturn = tempBalance?.expenses_fixed_list
          ?.filter(
            (item) => item.options_expenses_fixed === "expenses_insuarant_life"
          )
          ?.map((item) => item.expenses_insuarant_lifes)
          ?.flat();

        let tempBalanceData = {};
        //=============เงินลงทุนอื่น ๆ (สินทรัพย์ทางเลือก)=============//

        if (
          tempBalance?.property_invest_list
            ?.map((item) => item.options_property_invest_title)
            .includes("เงินลงทุนอื่น ๆ (สินทรัพย์ทางเลือก)") &&
          tempInsuranceReturn?.length === 0
        ) {
          // ถ้ามีหัวข้อนี้อยู่แล้ว
          let tempNameList = tempBalance?.property_invest_list
            .find(
              (item) =>
                item?.options_property_invest_title ===
                "เงินลงทุนอื่น ๆ (สินทรัพย์ทางเลือก)"
            )
            ?.invest_other_lists?.filter((item) => item !== null)
            ?.map((item) => item?.title);

          let tempInvestList = tempBalance?.property_invest_list?.map(
            (item) => {
              if (item?.invest_other_lists) {
                let tempData = tempInsuranceReturn
                  ?.map((item2) => {
                    if (!tempNameList?.includes(item2.title))
                      return {
                        amount: item2?.more_details?.policy_surrender_value,
                        created: item2.created,
                        reward_amount_per_year:
                          item?.reward_amount_per_year || 1,
                        target_invest: {},
                        title: item2.title,
                        editable: false,
                      };
                  })
                  .filter((item) => item !== undefined);
                return {
                  ...item,
                  invest_other_lists: [...item.invest_other_lists, ...tempData],
                };
              }
              return item;
            }
          );

          tempBalanceData = tempInvestList;
        } else {
          // ถ้ายังไม่มีหัวข้อนี้อยู่
          let tempInvestList = tempInsuranceReturn?.map((item) => {
            return {
              amount: item?.more_details?.policy_surrender_value,
              created: item.created,
              reward_amount_per_year: item?.reward_amount_per_year || 1,
              target_invest: item?.target_invest || {},
              title: item.title,
              editable: true,
            };
          });

          tempBalanceData = tempInvestList;
        }
        let tempReturnInsurance = [...ReturnInsurance];
        tempReturnInsurance[index] = tempBalanceData;
        setReturnInsurance(tempReturnInsurance);
      }
    });
    //==============================================//
  }, [allData]);

  const years = allData?.map((item, index) => {
    if (!item?.createdAt) {
      // return new Date().getFullYear() + 543 ;
      return null;
    }
    const d = new Date(item.createdAt);
    // Convert to Buddhist Era (BE)
    return d.getFullYear() + 543;
  });

  // Bar chart data
  const barChartData = {
    labels: allData?.map((item, index) => {
      return years[index] || THisYear + index;
    }),
    datasets: [
      {
        label: "สินทรัพย์",
        data: [
          Number(allData[0]?.balanceData?.sum_property_asset || 0) +
            SumDebtPersonalValue(allData[0]?.balanceData) +
            sumCapitalInvest(
              allData[0]?.balanceData?.property_invest_list,
              ReturnInsurance[0]
            ) +
            sumDebtInvest(allData[0]?.balanceData) +
            Number(allData[0]?.balanceData?.sum_property_private || 0) +
            SumOtherDebtAmount(allData[0]?.balanceData) +
            Number(allData[0]?.balanceData?.sum_property_intangible || 0),
          Number(allData[1]?.balanceData?.sum_property_asset || 0) +
            SumDebtPersonalValue(allData[1]?.balanceData) +
            sumCapitalInvest(
              allData[1]?.balanceData?.property_invest_list,
              ReturnInsurance[1]
            ) +
            sumDebtInvest(allData[1]?.balanceData) +
            Number(allData[1]?.balanceData?.sum_property_private || 0) +
            SumOtherDebtAmount(allData[1]?.balanceData) +
            Number(allData[1]?.balanceData?.sum_property_intangible || 0),
          Number(allData[2]?.balanceData?.sum_property_asset || 0) +
            SumDebtPersonalValue(allData[2]?.balanceData) +
            sumCapitalInvest(
              allData[2]?.balanceData?.property_invest_list,
              ReturnInsurance[2]
            ) +
            sumDebtInvest(allData[2]?.balanceData) +
            Number(allData[2]?.balanceData?.sum_property_private || 0) +
            SumOtherDebtAmount(allData[2]?.balanceData) +
            Number(allData[2]?.balanceData?.sum_property_intangible || 0),
          Number(allData[3]?.balanceData?.sum_property_asset || 0) +
            SumDebtPersonalValue(allData[3]?.balanceData) +
            sumCapitalInvest(
              allData[3]?.balanceData?.property_invest_list,
              ReturnInsurance[3]
            ) +
            sumDebtInvest(allData[3]?.balanceData) +
            Number(allData[3]?.balanceData?.sum_property_private || 0) +
            SumOtherDebtAmount(allData[3]?.balanceData) +
            Number(allData[3]?.balanceData?.sum_property_intangible || 0),
        ],
        backgroundColor: "#0A3D62",
      },
      {
        label: "หนี้สิน",
        data: [
          allData[0]?.balanceData?.sum_debt_short +
            allData[0]?.balanceData?.sum_debt_long,
          allData[1]?.balanceData?.sum_debt_short +
            allData[1]?.balanceData?.sum_debt_long,
          allData[2]?.balanceData?.sum_debt_short +
            allData[2]?.balanceData?.sum_debt_long,
          allData[3]?.balanceData?.sum_debt_short +
            allData[3]?.balanceData?.sum_debt_long,
        ],
        backgroundColor: "#7FB3D5",
      },
      {
        label: "ความมั่งคั่งสุทธิ",
        data: [
          allData[0]?.balanceData?.net_wealth,
          allData[1]?.balanceData?.net_wealth,
          allData[2]?.balanceData?.net_wealth,
          allData[3]?.balanceData?.net_wealth,
        ], // Will be calculated
        backgroundColor: "#AED6F1",
      },
    ],
  };

  // // Calculate the total height for each bar
  // barChartData.datasets[2].data = barChartData.datasets[0].data?.map(
  //   (netCash, i) => {
  //     return netCash + barChartData.datasets[1].data[i];
  //   }
  // );

  // Line chart data
  const lineChartData = {
    labels: years,
    datasets: barChartData.datasets?.map((barDataset) => ({
      label: barDataset.label,
      data: [...barDataset.data],
      borderColor: barDataset.backgroundColor,
      backgroundColor: barDataset.backgroundColor,
      borderWidth: 2,
      pointRadius: 2,
      pointHoverRadius: 8,
      tension: 0.1,
    })),
  };

  // Bar chart options
  const barChartOptions = {
    devicePixelRatio: 5,
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        grid: {
          display: false,
        },
        ticks: {
          font: {
            size: 8, // ← X‐axis label size
            weight: "400", // optional
          },
        },
      },
      y: {
        beginAtZero: true,
        ticks: {
          callback: (value) => {
            if (value === 0) return "0";
            return `${Number(value) / 1000000}M`;
          },
          font: {
            size: 8,
            weight: "400",
          },
          stepSize: 100000000,
        },
        grid: {
          color: "#E5E7EB",
        },
      },
    },
    plugins: {
      tooltip: {
        callbacks: {
          label: (context) => {
            let label = context.dataset.label || "";
            if (label) {
              label += ": ";
            }
            if (context.parsed.y !== null) {
              label += new Intl.NumberFormat("th-TH", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }).format(context.parsed.y);
            }
            return label;
          },
        },
      },
      legend: {
        display: false,
        position: "bottom",
        labels: {
          display: false,
          usePointStyle: false, // ← turn OFF point styles so you get rectangles
          boxWidth: 50, // ← how wide the little swatch is
          boxHeight: 12, // ← how tall the little swatch is
          padding: 20, // ← space between items
          font: {
            size: 6, // ← set your desired font size (px)
            weight: "500", // optional: 'normal', 'bold', or numeric
          },
        },
      },
    },
  };

  // Line chart options
  const lineChartOptions = {
    devicePixelRatio: 5,
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      y: {
        ticks: {
          callback: (value) => {
            if (value === 0) return "0";
            return `${Number(value) / 1000000}M`;
          },
          stepSize: 100000000,
          font: {
            size: 8,
            weight: "400",
          },
        },
        grid: {
          color: "#E5E7EB",
        },
      },
      x: {
        grid: {
          display: false,
        },
        ticks: {
          font: {
            size: 8, // ← X‐axis label size
            weight: "400", // optional
          },
        },
      },
    },
    plugins: {
      legend: {
        position: "bottom",
        display: false,
        labels: {
          usePointStyle: false,
          padding: 20,
        },
      },
    },
  };

  function formatToThaiDate(isoString) {
    if (!isoString) return "";
    const d = new Date(isoString);
    const day = d.getDate();
    const month = d.getMonth() + 1;
    const year = d.getFullYear() + 543;
    return `${day}/${month}/${year}`;
  }

  return (
    <div className="bg-blue-50 rounded-xl p-[15px] mt-5 ">
      {/* Header */}
      <div className="bg-white rounded-xl py-[10px] px-[5px] shadow-sm">
        <div className="flex items-center gap-[5px]">
          <img
            src="images/personal-report.png"
            alt="Description"
            width={14}
            height={14}
          />
          <h1 className={cn(STYLE_PDF_TEXT_MEDIUM_11, "font-bold")}>
            ตารางสรุปการวิเคราะห์ทางการเงิน
          </h1>
        </div>
      </div>

      {/* Section Title */}
      <div>
        <h2 className={cn(STYLE_PDF_TEXT_NORMAL_10, "font-bold my-[10px]")}>
          2. สินทรัพย์ หนี้สิน ความมั่งคั่งสุทธิ
        </h2>
      </div>
      <div className="bg-white rounded-[14px]">
        {/* Table */}
        <div className="overflow-x-auto mb-6">
          <table className="w-full h-fit rounded-t-[10px] ">
            <thead className="rounded-t-[10px]">
              <tr className="">
                <th
                  className={cn(
                    STYLE_PDF_TEXT_MEDIUM_BLUE_12,
                    " font-semibold text-left  h-full w-fit p-0 "
                  )}
                >
                  <div className="pl-[5px] pb- h-full w-full bg-gray-100 rounded-tl-[10px] border-l-0 border-r-[0.5px] border-t-[0.5px] border-gray-200 ">
                    รายละเอียด
                  </div>
                </th>
                {allData?.map((item, index) => (
                  <th
                    key={index}
                    className={cn(
                      STYLE_PDF_TEXT_MEDIUM_BLUE_12,
                      ` font-semibold text-center text-[10px] p-0 h-full`
                    )}
                  >
                    <div
                      className={cn(
                        `${STYLE_PDF_TEXT_MEDIUM_BLUE_12} border border-l-0 border-b-0`,
                        ` font-semibold text-center text-[10px] h-full w-full bg-gray-100 border-gray-200 ${
                          index === 3
                            ? "rounded-tr-[10px] border-r-[0.5px]"
                            : ""
                        }`
                      )}
                    >
                      {years[index] || THisYear + index}
                      <div
                        className={cn(
                          STYLE_PDF_TEXT_MEDIUM_BLUE_12,
                          "text-[8px]"
                        )}
                      >
                        {years[index] && (
                          <span>
                            แก้ไขข้อมูลล่าสุด {formatToThaiDate(item.createdAt)}
                          </span>
                        )}
                      </div>
                    </div>
                  </th>
                ))}
              </tr>
            </thead>

            <tbody>
              {/* Category Header - งบดุล */}
              <tr className="border-b-[1px] border-b-[#18488A]">
                <td className="p-0 bg-white ">
                  <div className="flex items-center pl-[5px] py-[3px] border-l-0 border-t-0 border-[0.5px]  border-gray-200 border-b-0 ">
                    {/* handholdmoneyandhouse.png */}
                    <img
                      src="images/handholdmoneyandhouse.png"
                      alt="Description"
                      width={14}
                      height={14}
                      className="mr-[5px]"
                    />
                    <span
                      className={cn(
                        STYLE_PDF_TEXT_MEDIUM_BLUE_12,
                        "font-semibold text-[9px] text-black"
                      )}
                    >
                      งบดุล
                    </span>
                  </div>
                </td>
                <td className=" p-0 ">
                  <div className="!w-full !h-full border-l-0 border-t-0 border-[0.5px]  border-gray-200 border-b-0 "></div>
                </td>
                <td className=" p-0 ">
                  <div className="!w-full !h-full border-l-0 border-t-0 border-[0.5px]  border-gray-200 border-b-0 "></div>
                </td>
                <td className=" p-0">
                  <div className="!w-full !h-full border-l-0 border-t-0 border-[0.5px] border-r-[0.5px] border-gray-200 border-b-0 "></div>
                </td>
              </tr>

              {/* รายรับ Category */}
              <tr className="h-fit w-fit">
                <td className=" text-[8px] p-0 text-[#00A9A0] font-medium ">
                  <div className=" w-full h-full p-[1px] pl-[5px] border-l-0 border-t-0 border-[0.5px]">
                    หนี้สิน
                  </div>
                </td>
                {allData?.map((itemA, index) => (
                  <td
                    key={index}
                    className=" text-[8px] p-0 text-center text-[#18488A] font-medium"
                  >
                    <div
                      className={cn(
                        " w-full h-full p-[1px] pl-[5px] border-r-[0.5px] border-b-[0.5px]"
                        // { "border-r-0": index === 3 }
                      )}
                    >
                      {itemA?.balanceData?.sum_debt_short +
                      itemA?.balanceData?.sum_debt_long
                        ? numeral(
                            itemA?.balanceData?.sum_debt_short +
                              itemA?.balanceData?.sum_debt_long
                          ).format("0,0")
                        : "-"}
                    </div>
                  </td>
                ))}
              </tr>

              {/* รายรับ Subcategories */}
              {[
                { name: "ระยะสั้น", value: "sum_debt_short" },
                { name: "ระยะยาว", value: "sum_debt_long" },
              ]?.map((itemA, index) => (
                <tr key={index} className="h-fit w-fit">
                  <td className=" font-medium text-[8px] p-0 text-[#18488A]">
                    <div className=" w-full h-full p-[1px] pl-[10px] border-l-0 border-t-0 border-[0.5px]">
                      {itemA.name}
                    </div>
                  </td>
                  {allData?.map((item, idx) => (
                    <td
                      key={idx}
                      className=" font-normal text-[7px] p-[0px] text-[#18488A] text-center"
                    >
                      <div
                        className={cn(
                          " w-full h-full p-[1px] pl-[5px] border-r-[0.5px] border-b-[0.5px]"
                          // { "border-r-0": idx === 3 }
                        )}
                      >
                        {item?.balanceData?.[itemA.value]
                          ? numeral(item?.balanceData?.[itemA.value]).format(
                              "0,0"
                            )
                          : "-"}
                      </div>
                    </td>
                  ))}
                </tr>
              ))}

              {/* สินทรัพย์ Category */}
              <tr className="h-fit w-fit">
                <td className=" text-[8px] p-[0px] text-[#00A9A0] font-medium">
                  <div className=" w-full h-full p-[1px] pl-[5px] border-l-0 border-t-0 border-[0.5px]">
                    สินทรัพย์
                  </div>
                </td>
                {allData?.map((itemA, index) => {
                  // console.log("index", index);
                  // console.log("ReturnInsurance[index]", ReturnInsurance[index]);
                  // console.log(
                  //   "gggg",
                  //   sumCapitalInvest(
                  //     itemA?.balanceData?.property_private_list,
                  //     ReturnInsurance[index]
                  //   )
                  // );
                  // console.log("---------");
                  return (
                    <td
                      key={index}
                      className=" text-[8px] p-[0] text-center text-[#18488A] font-medium"
                    >
                      <div
                        className={cn(
                          " w-full h-full p-[1px] pl-[5px] border-r-[0.5px] border-b-[0.5px]"
                          // { "border-r-0": index === 3 }
                        )}
                      >
                        {Number(itemA?.balanceData?.sum_property_asset || 0) +
                          SumDebtPersonalValue(itemA?.balanceData) +
                          sumCapitalInvest(
                            itemA?.balanceData?.property_invest_list,
                            ReturnInsurance[index]
                          ) +
                          sumDebtInvest(itemA?.balanceData) +
                          Number(
                            itemA?.balanceData?.sum_property_private || 0
                          ) +
                          SumOtherDebtAmount(itemA?.balanceData) +
                          Number(
                            itemA?.balanceData?.sum_property_intangible || 0
                          ) >
                        0
                          ? numeral(
                              Number(
                                itemA?.balanceData?.sum_property_asset || 0
                              ) +
                                SumDebtPersonalValue(itemA?.balanceData) +
                                sumCapitalInvest(
                                  itemA?.balanceData?.property_invest_list,
                                  ReturnInsurance[index]
                                ) +
                                sumDebtInvest(itemA?.balanceData) +
                                Number(
                                  itemA?.balanceData?.sum_property_private || 0
                                ) +
                                SumOtherDebtAmount(itemA?.balanceData) +
                                Number(
                                  itemA?.balanceData?.sum_property_intangible ||
                                    0
                                )
                            ).format("0,0")
                          : "-"}
                      </div>
                    </td>
                  );
                })}
              </tr>

              {/* สินทรัพย์ Subcategories */}
              {[
                { name: "สภาพคล่อง", value: "sum_property_asset" },
                { name: "สินทรัพย์เพื่อการลงทุน", value: "200,000" },
                { name: "สินทรัพย์ใช้ส่วนตัว", value: "200,000" },
                { name: "สินทรัพย์ไม่มีตัวตน", value: "200,000" },
              ]?.map((itemA, index) => (
                <tr key={index}>
                  <td className=" font-medium text-[8px] p-0 text-[#18488A]">
                    <div className=" w-full h-full p-[1px] pl-[10px] border-l-0 border-t-0 border-[0.5px]">
                      {itemA.name}
                    </div>
                  </td>
                  {allData?.map((item, idx) => {
                    
                    return (
                      <td
                        key={idx}
                        className=" font-normal text-[7px] p-0 text-[#18488A] text-center"
                      >
                        <div
                          className={cn(
                            " w-full h-full p-[1px] pl-[5px] border-r-[0.5px] border-b-[0.5px]"
                            // { "border-r-0": idx === 3 }
                          )}
                        >
                          {itemA.name === "สภาพคล่อง" &&
                            (item?.balanceData?.sum_property_asset
                              ? numeral(
                                  item?.balanceData?.sum_property_asset
                                ).format("0,0")
                              : "-")}
                          {itemA.name === "สินทรัพย์เพื่อการลงทุน" &&
                            (SumDebtPersonalValue(item?.balanceData) +
                            sumCapitalInvest(
                              item?.balanceData?.property_invest_list,
                              ReturnInsurance[index]
                            ) +
                            sumDebtInvest(item?.balanceData)
                              ? numeral(
                                  SumDebtPersonalValue(item?.balanceData) +
                                    sumCapitalInvest(
                                      item?.balanceData?.property_invest_list,
                                      ReturnInsurance[index]
                                    ) +
                                    sumDebtInvest(item?.balanceData)
                                ).format("0,0")
                              : "-")}
                          {itemA.name === "สินทรัพย์ใช้ส่วนตัว" &&
                            (item?.balanceData?.sum_property_private +
                            SumOtherDebtAmount(item?.balanceData)
                              ? numeral(
                                  item?.balanceData?.sum_property_private +
                                    SumOtherDebtAmount(item?.balanceData)
                                ).format("0,0")
                              : "-")}
                          {itemA.name === "สินทรัพย์ไม่มีตัวตน" &&
                            (item?.balanceData?.sum_property_intangible
                              ? numeral(
                                  item?.balanceData?.sum_property_intangible
                                ).format("0,0")
                              : "-")}
                        </div>
                      </td>
                    );
                  })}
                </tr>
              ))}

              {/* ความมั่งคั่งสุทธิ */}
              <tr className="h-fit w-fit">
                <td className=" text-[8px] p-0 text-[#00A9A0] font-medium">
                  <div className=" w-full h-full p-[1px] pl-[5px] border-l-0 border-t-0 border-[0.5px]">
                    ความมั่งคั่งสุทธิ
                  </div>
                </td>
                {allData?.map((item, index) => (
                  <td
                    key={index}
                    className=" font-normal text-[7px] p-0 text-[#18488A] text-center"
                  >
                    <div
                      className={cn(
                        " w-full h-full p-[1px] pl-[5px] border-r-[0.5px] border-b-[0.5px]"
                        // { "border-r-0": index === 3 }
                      )}
                    >
                      {item?.balanceData?.net_wealth
                        ? numeral(item?.balanceData?.net_wealth).format("0,0")
                        : "-"}
                    </div>
                  </td>
                ))}
              </tr>
            </tbody>
          </table>
        </div>

        {/* Charts */}
        <div className="flex flex-row justify-center pb-[30px] ">
          {/* Bar Chart */}
          <div className="bg-white pl-3 w-fit">
            <div className="mb-2 text-[8px] ">หน่วย : บาท</div>
            <div className="w-[242px] h-[150px]">
              <Bar data={barChartData} options={barChartOptions} />
            </div>
            <div className="flex flex-row w-full mt-[10px] space-x-[13px] pl-[20px]">
              <div className="w-fit h-fit flex flex-row ">
                <div className="!w-[21px] !h-[8px] bg-[#18488A]"></div>
                <div className="pl-1 text-[6px]">สินทรัพย์</div>
              </div>
              <div className="w-fit h-fit flex flex-row ">
                <div className="!w-[21px] !h-[8px] bg-[#A9B4CC]"></div>
                <div className="pl-1 text-[6px]">หนี้สิน</div>
              </div>
              <div className="w-fit h-fit flex flex-row ">
                <div className="!w-[21px] !h-[8px] bg-[#B5D4FF]"></div>
                <div className="pl-1 text-[6px]">ความมั่งคั่งสุทธิ</div>
              </div>
            </div>
          </div>

          {/* Line Chart */}
          {/* <div className="bg-white pl-3 w-full ">
            <div className="mb-2 text-[8px] ">หน่วย : %</div>
            <div className="w-[242px] h-[150px]">
              <Line data={lineChartData} options={lineChartOptions} />
            </div>
            <div className="flex flex-row w-full mt-[10px] space-x-[13px] pl-[20px]">
              <div className="w-fit h-fit flex flex-row ">
                <div className="!w-[21px] !h-[8px] bg-[#18488A]"></div>
                <div className="pl-1 text-[6px]">สินทรัพย์</div>
              </div>
              <div className="w-fit h-fit flex flex-row ">
                <div className="!w-[21px] !h-[8px] bg-[#A9B4CC]"></div>
                <div className="pl-1 text-[6px]">หนี้สิน</div>
              </div>
              <div className="w-fit h-fit flex flex-row ">
                <div className="!w-[21px] !h-[8px] bg-[#B5D4FF]"></div>
                <div className="pl-1 text-[6px]">ความมั่งคั่งสุทธิ</div>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default AnalysisTableTwo;
